module.exports = __webpack_public_path__ + "img/deggendorf_hochaltar.c1c54592.jpg";